import React from 'react'
import clsx from 'clsx'
import { AccordionItem } from './accordion-item'
import { AccordionButton } from './accordion-button'
import { AccordionContent } from './accordion-content'
import { AccordionIndexType, AccordionProvider } from './accordion-context'

import * as styles from './accordion.module.scss'

type Variant = 'light' | 'arrow'

type Props = React.ComponentProps<'div'> & {
  isOpen?: AccordionIndexType
  isActive?: boolean
  variant?: Variant | null
}

const BaseAccordion = ({
  className,
  children,
  variant,
  isOpen,
  isActive,
  ...props
}: Props) => {
  return (
    <AccordionProvider isOpen={isOpen} isActive={isActive}>
      <div
        className={clsx(
          styles.accordion,
          variant && styles[variant],
          className
        )}
        {...props}
      >
        {children}
      </div>
    </AccordionProvider>
  )
}

export const Accordion = Object.assign(BaseAccordion, {
  Item: AccordionItem,
  Button: AccordionButton,
  Content: AccordionContent,
})
